document.addEventListener("DOMContentLoaded", function () {
    const CLASS_TRIGGER = "jdgm-paginate__load-more";
    const metafieldJson = JSON.parse(document.querySelector("#metafield-review").innerHTML) || [];
    const shopifyAppBlock = document.querySelector(".shopify-app-block");
  
    let observer = new MutationObserver((mutationRecords) => {
      const judgemeReviews = document.querySelector("#judgeme_product_reviews");
      if (judgemeReviews) {
        observer.disconnect();
        changeText();
        judgemeReviews.addEventListener("click", handleLoadMore);
      }
    });
  
    observer.observe(shopifyAppBlock, {
      childList: true,
      subtree: true,
      characterDataOldValue: true,
    });
  
    function changeText() {
      const jdmRevs = document.querySelectorAll(".jdgm-rev__content");
    
      jdmRevs.forEach((currentElement, i) => {
        if (currentElement.getAttribute("data-change") === "true") {
          return; 
        }
    
        const metafieldData = metafieldJson[i];
    
        if (metafieldData) {
          const { body, title } = metafieldData;
    
          const titleElement = currentElement.querySelector(".jdgm-rev__title");
          const bodyElement = currentElement.querySelector(".jdgm-rev__body p");
    
          if (titleElement && bodyElement) {
            titleElement.textContent = title;
            bodyElement.textContent = body;
            currentElement.setAttribute("data-change", "true");
          }
        }
      });
    }
    
  
    function handleLoadMore(event) {
      if (event.target.classList.contains(CLASS_TRIGGER)) {
        const reviewsContainer = document.querySelector(".jdgm-rev-widg__reviews");
        changeTextAfterLoadMore(reviewsContainer);
      }
    }
  
    function changeTextAfterLoadMore(element) {
      if (!element) return;
  
      let observer = new MutationObserver(() => {
        if (element) {
          changeText();
          observer.disconnect();
        }
      });
  
      observer.observe(element, {
        childList: true,
        subtree: true,
        characterDataOldValue: true,
      });
    }
  });
  